$(document).ready(function(){
    $('.badge-list').prependTo('.product-gallery');
});

$(document).ready(function() {
    $('section#shopify-section-template--15820133597271__rich_text_naDReh em').html('<span class="star_icon"></span><span class="star_icon"></span><span class="star_icon"></span><span class="star_icon"></span><span class="star_icon"></span>');

    $('section#shopify-section-template--15820133597271__image_with_text_FTba9E em').html('<span class="star_icon"></span><span class="star_icon"></span><span class="star_icon"></span><span class="star_icon"></span><span class="star_icon"></span>');
});

$(document).ready(function() {
  // Check if the screen width is greater than 768px (desktop)
  if ($(window).width() > 768) {
    // The image to prepend
    var imgHtml = '<img src="https://cdn.shopify.com/s/files/1/1212/4268/files/img.png?v=1720179242" alt="Prepended Image" />';
    
    // Prepend the image
    $('section#shopify-section-template--15820133597271__image_with_text_HDEPAE img').before(imgHtml);
  }
});


  document.addEventListener('DOMContentLoaded', function() {
    var accordionHeaders = document.querySelectorAll('.accordion-header');
    
    accordionHeaders.forEach(function(header) {
      header.addEventListener('click', function() {
        var content = header.nextElementSibling;
        var icon = header.querySelector('.accordion-icon');
        
        content.classList.toggle('show');
        header.classList.toggle('active');
        
        /*if (content.classList.contains('show')) {
          icon.innerHTML = '&#x25B2;'; // Up arrow
        } else {
          icon.innerHTML = '&#x25BC;'; // Down arrow
        }*/
      });
    });
  });

document.addEventListener('DOMContentLoaded', function () {
    var videoSliderElement = document.querySelector('#shopify-section-template--15820133826647__custom_video_slider_7a7FEq .video-slider');
    var flkty = new Flickity(videoSliderElement);

    function checkScreenSize() {
        if (window.innerWidth > 1024) {
            // Destroy Flickity for desktop screens (width > 1024px)
            if (flkty) {
                flkty.destroy();
                flkty = null; // Set to null to avoid multiple calls
            }
        } else {
            // Reinitialize Flickity for smaller screens if needed
            if (!flkty) {
                flkty = new Flickity(videoSliderElement);
            }
        }
    }

    // Initial check
    checkScreenSize();

    // Check screen size on window resize
    window.addEventListener('resize', checkScreenSize);
});





$(document).ready(function() {
    // Function to truncate text
    function truncateText(selector, maxLength) {
        var element = $(selector);
        var originalText = element.text();

        if (originalText.length > maxLength) {
            var truncatedText = originalText.substr(0, maxLength) + '... ';
            var readMore = $('<a href="#" class="read-more">Read More</a>');

            element.data('original-text', originalText);
            element.text(truncatedText);
            element.append(readMore);
        }
    }

    // Apply truncate function to each p.text_under_title
    $('product-card.product-card p.text_under_title').each(function() {
        truncateText(this, 65);
    });

    // Event listener for Read More link
    $('body').on('click', '.read-more', function(event) {
        event.preventDefault();
        var element = $(this).parent();
        element.text(element.data('original-text'));
    });
});



/* Collection page sliders */
/* Implemented in plain JS because of the performance since there is a lot of sliders per page */

class CardProductGallery extends HTMLElement {
  constructor() {
    super();
    this.threshold = 60,
    this.wasDragged = false,
    this.startX = 0,
    this.endX = 0;
    this.cumulativeY = 0;
    this.scrollStarted = null;
    this.images = null;
    this.navSwatches = null;

    this.currentImageIndex = 0;
  }

  connectedCallback() {
    this.images = this.querySelectorAll("img");
    this.navSwatches = this.querySelectorAll("[data-navigation-swatch]");

    this.addEventListener('touchstart', this.dragStart);
    this.addEventListener('touchend', this.dragEnd);
    this.addEventListener('touchmove', this.dragAction);

    this.navSwatches.forEach((swatch) => {
      swatch.addEventListener("click", (e) => {
        e.preventDefault();
        this.changeImage(swatch);
      });
    });
  }

  disconnectedFallback() {
    this.removeEventListener('touchstart', this.dragStart);
    this.removeEventListener('touchend', this.dragEnd);
    this.removeEventListener('touchmove', this.dragAction);
  }

  nextImage() {
    if(!this.images[this.currentImageIndex]) return;

    this.hideImageAtIndex(this.currentImageIndex);
    this.currentImageIndex++;
    if(this.currentImageIndex >= this.images.length) this.currentImageIndex = 0;

    this.showImageAtIndex(this.currentImageIndex);
  }

  previousImage() {
    if(!this.images[this.currentImageIndex]) return;

    this.hideImageAtIndex(this.currentImageIndex);
    this.currentImageIndex--;
    if(this.currentImageIndex < 0 ) this.currentImageIndex = this.images.length - 1;

    this.showImageAtIndex(this.currentImageIndex);
  }

  changeImage(swatch) {   
    const index = swatch.dataset.index;
    if(!this.images[this.currentImageIndex]) return;

    this.hideImageAtIndex(this.currentImageIndex);
    this.currentImageIndex = index;
    
    this.showImageAtIndex(this.currentImageIndex);
  }

  hideImageAtIndex(index) {
    this.images[index].classList.add("collection-gallery-image--hidden");
    this.navSwatches[this.currentImageIndex].classList.add("not-active");
  }
  
  showImageAtIndex(index) {
    this.images[index].classList.remove("collection-gallery-image--hidden");
    this.navSwatches[this.currentImageIndex].classList.remove("not-active");
  }

  dragStart (e) {
    if(document.body.hasAttribute("data-disable-collection-gallery")) return;

    e = e || window.event;
    if (e.type == 'touchstart') {
      this.startX = e.touches[0].clientX;
    } else {
      this.startX = e.clientX;
      document.onmouseup = this.dragEnd;
      document.onmousemove = this.dragAction;
    }
  }

  dragAction (e) {
    if(document.body.hasAttribute("data-disable-collection-gallery")) return;

    this.wasDragged = true;
    e = e || window.event;

    if (e.type == 'touchmove') {
      this.endX = e.touches[0].clientX;
    } else {
      this.endX = e.clientX;
    }

    if(Math.abs(this.cumulativeY) > 30){
      this.cumulativeY = 0;
      return;
    }
  }

  dragEnd (e) {
    if(document.body.hasAttribute("data-disable-collection-gallery")) return;
    
    if(!this.wasDragged){
      this.click();
    }

    if (this.endX - this.startX < -this.threshold) {
      this.nextImage();
    } else if (this.endX - this.startX > this.threshold) {
      this.previousImage();
    } 
    this.wasDragged = false;
    document.onmouseup = null;
    document.onmousemove = null;
    this.scrollStarted = false;
  }
}

customElements.define('card-product-gallery', CardProductGallery);